import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./contactUs.css";

function ContactUs() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const handleSubmit = async () => {

  if (!form.name.trim() || !form.message.trim()) {
    alert("Please fill required fields");
    return;
  }

  setLoading(true);

  try {

    const response = await fetch(
      "https://vedonica.in/api/auth/contact/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      }
    );

    const data = await response.json();

    if (response.ok) {

      setSubmitted(true);

      setTimeout(() => {
        setSubmitted(false);
      }, 3000);

      setForm({
        name: "",
        email: "",
        phone: "",
        message: "",
      });

    } else {

      alert(data.message || "Something went wrong");

    }

  } catch (error) {

    console.log("CONTACT FORM ERROR:", error);

    alert("Server Error");

  } finally {

    setLoading(false);

  }
};
  const contactCards = [
    { icon: "✉", label: "Email Support", value: "vedonicainternational@gmail.com", sub: "General inquiries" },
    { icon: "☎", label: "Phone / WhatsApp", value: "+91 83684 02126", sub: "Shweta Gupta – Owner" },
    { icon: "📍", label: "Office Address", value: "Vedonica International", sub: "91, Saipuram Villa 2nd, Raj Nagar Extension, Uttar Pradesh - 201017" },
    { icon: "🕐", label: "Business Hours", value: "Mon – Sat", sub: "10:00 AM to 7:00 PM" },
    // { icon: "📦", label: "Wholesale Inquiry", value: "sales@vedonica.com", sub: "Bulk & B2B orders" },
    { icon: "💬", label: "Customer Care", value: "Reply within 24 hrs", sub: "We're here to help" },
  ];

  return (
    <div className="contact-page">
      <div className="contact-container">

        {/* Header */}
        <div className="contact-header">
          <span className="badge">Support • Help • Connect</span>
          <h1>Contact <span className="brand">Vedonica International</span></h1>
          <p>We'd love to hear from you. Reach out for orders,<br />support, partnerships, or product inquiries.</p>
        </div>

        {/* Owner Card */}
        {/* <div className="owner-card">
          <div className="owner-avatar">SG</div>
          <div className="owner-info">
            <p className="owner-name">Shweta Gupta</p>
            <p className="owner-role">Founder & Owner, Vedonica</p>
          </div>
          <a href="tel:+918368402126" className="owner-call-btn">Call Now</a>
        </div> */}

        {/* Contact Grid */}
        <div className="contact-grid">
          {contactCards.map((card, i) => (
            <div className="contact-card" key={i}>
              <span className="card-icon">{card.icon}</span>
              <h2>{card.label}</h2>
              <p className="card-value">{card.value}</p>
              <p className="card-sub">{card.sub}</p>
            </div>
          ))}
        </div>

        {/* Contact Form */}
        <div className="form-section">
          <h3 className="form-title">Send us a Message</h3>
          <p className="form-sub">Fill in the form and we'll get back to you within 24 hours.</p>

          <div className="form-grid">
            <div className="form-group">
              <label>Your Name *</label>
              <input
                type="text"
                name="name"
                placeholder="e.g. Priya Sharma"
                value={form.name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                placeholder="you@example.com"
                value={form.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="tel"
                name="phone"
                placeholder="+91 XXXXX XXXXX"
                value={form.phone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group full-width">
              <label>Message *</label>
              <textarea
                name="message"
                placeholder="How can we help you?"
                rows={4}
                value={form.message}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-footer">
            {submitted && <span className="success-msg">✓ Message sent! We'll be in touch soon.</span>}
            <button
  type="button"
  className="submit-btn"
  onClick={handleSubmit}
  disabled={loading}
>
  {loading ? "Sending..." : "Send Message"}
</button>
          </div>
        </div>

        {/* Back Button */}
        <div className="contact-footer">
          <button className="home-btn" onClick={() => navigate("/")}>← Back to Home</button>
        </div>

      </div>
    </div>
  );
}

export default ContactUs;